var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title",style:({'width':_vm.width+'px'})},[_c('span',[_vm._v(_vm._s(_vm.title))]),(_vm.show)?_c('span',{on:{"click":_vm.goPath}},[_vm._v("更多")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }